<template>
  <div class="emission-update-page page-layout">
    <PageHeader
      title="Modifier taxe sur vehicule société (émissions de CO₂)"
      :has-back="true"
      @back="goBack"
    />

    <md-card class="meep-form">
      <md-card-content>
        <div class="meep-form-column meep-form-single-column">
          <!--emission min-->
          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('emission_min') }">
              <label>Emission min *</label>
              <md-input
                v-model="form.emission_min"
                v-validate="'required|decimal'"
                name="emission_min"
                type="emission_min"
              />
              <span class="md-error" v-show="errors.has('emission_min')">{{
                errors.first("emission_min")
              }}</span>
            </md-field>
          </div>

          <!--emission max-->
          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('emission_max') }">
              <label>Emission max*</label>
              <md-input
                v-model="form.emission_max"
                v-validate="'decimal'"
                name="emission_max"
                type="emission_max"
              />
              <span class="md-error" v-show="errors.has('emission_max')">{{
                errors.first("emission_max")
              }}</span>
            </md-field>
          </div>

          <!--coef1a19-->
          <div class="meep-input">
            <md-field :class="{ 'md-invalid': errors.has('coef') }">
              <label>Coef*</label>
              <md-input
                v-model="form.coef"
                v-validate="'required|decimal'"
                name="coef"
                type="coef"
              />
              <span class="md-error" v-show="errors.has('coef')">{{
                errors.first("coef")
              }}</span>
            </md-field>
          </div>

          <div class="md-layout md-alignment-center-right">
            <md-button
              class="md-raised md-primary"
              @click.native="updateEmission"
            >
              Valider
            </md-button>

            <md-button
              class="md-raised md-primary"
              @click.native="openConfirmDeleteModal"
            >
              Supprimer cette taxe
            </md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <confirm-action-modal
      v-if="isConfirmDeleteModalOpen"
      :text="confirmDeleteModalText"
      :objectToActUpon="form"
      @close="closeConfirmDeleteModal"
      @confirm="removeEmission"
    />
  </div>
</template>

<script>
import calculatorsModel from "../../../../model/calculators";
import confirmActionModal from "../../../../components/modal/confirm-action";
import PageHeader from "@/components/PageHeader";

export default {
  data() {
    return {
      isDebug: false,
      form: {
        emission_min: "",
        emission_max: "",
        coef: "",
      },
      isConfirmDeleteModalOpen: false,
      confirmDeleteModalText: {
        header: "Suppression d'une taxe",
        body() {
          return "Vous êtes sur le point de supprimer la taxe sur vehicule de société";
        },
        question: "Êtes-vous certain de vouloir le faire ?",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    calculatorsModel
      .getEmission(to.params.id)
      .then(formData => {
        next(vm => {
          vm.form = formData;
          if (vm.isDebug) {
            console.log("emission with id" + to.params.id + ":");
            console.log(vm.form);
          }
        });
      })
      .catch(() => {
        next(from.path);
      });
  },
  components: {
    PageHeader,
    "confirm-action-modal": confirmActionModal,
  },
  methods: {
    goBack() {
      window.history.back();
    },
    updateEmission() {
      this.$validator.validateAll().then(result => {
        if (result) {
          calculatorsModel
            .updateEmission(this.form)
            .then(() => {
              this.$toasted.global.AppSucces({
                message: "L'emission a bien été modifié",
              });
              this.$router.push(
                "/admin/calculators/taxe-vehicule-societe-emission/list"
              );
            })
            .catch(err => {
              this.$toasted.global.AppError({
                message: err.msg,
              });
            });
        } else {
          this.$toasted.global.AppInfo({
            message: "Vous devez remplir les champs manquants",
          });
        }
      });
    },
    removeEmission() {
      calculatorsModel
        .removeEmission(this.form.id)
        .then(() => {
          this.$toasted.global.AppSucces({
            message: "la taxe sur les véhicules de société a suprimé",
          });
          this.$router.push(
            "/admin/calculators/taxe-vehicule-societe-emission/list"
          );
        })
        .catch(err => {
          this.$toasted.global.AppError({
            message: err.msg,
          });
        });
    },
    openConfirmDeleteModal() {
      this.isConfirmDeleteModalOpen = true;
    },
    closeConfirmDeleteModal() {
      this.isConfirmDeleteModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.emission-update-page {
  .debug-log {
    max-height: 360px;
    overflow-y: scroll;
  }

  .md-card {
    margin: 32px auto;
  }
}
</style>
